(ns frontend.view.components.form.cards
  (:require
   [frontend.utils :as main-utils]
   [frontend.utils :as fu]
   [frontend.view.components.form.view :as form]
   [reagent.core :as r]
   [ui.components.card.view :as card]))

(defn card-field-input
  [{:keys [entity field accounts guest-accounts tenant-roles options field-description
           mandatory? error? edit? read-only? validate!
           on-change! on-save! cancel-edit! search-entity! create-entity! get-entity!
           hide-empty-fields?] :as _view-args}]
  (let [value (cond
                (:value-attribute field)
                ((:value-attribute field) entity)

                (= (:type field) "currency--sym")
                (->> entity
                     ((:attribute field))
                     main-utils/if-bigdec-then-float)

                (= (:type field) "guest")
                (vec (filter (fn [v]
                               (= (:role/role v)
                                  (:attribute field)))
                             (:guests field)))

                :else
                ((:attribute field) entity))
        draw? (or (not hide-empty-fields?) (not (fu/empty-value? value)))]
    (when draw?
      [form/view
       (merge {:label             (:field-name field)
               :entity            entity
               :options           options
               :type              (:type field)
               :value             value
               :wrapper           "zap-form__light-grey__green__sand"
               :field             field
               :error?            error?
               :read-only?        read-only?
               :accounts          accounts
               :tenant-roles      tenant-roles
               :guest-accounts    guest-accounts
               :mandatory?        mandatory?
               :search-entity!    search-entity!
               :get-entity!       get-entity!
               :validate!         validate!
               :create-entity!    create-entity!
               :edit?             edit?
               :field-description (when field-description (field-description (:attribute field)))
               :on-change!        #(on-change!
                                    (:attribute field)
                                    %)
               :control-id        (:attribute field)
               :on-save!          on-save!
               :cancel-edit!      cancel-edit!}
              (when (= (:type field) "currency--sym")
                ;; This is for editing currency symbols as well
                (let [attr (keyword (name (:entity field))                                          ;; fetches :oppo or :company
                                    (str (name (:attribute field)) "--sym"))]                       ;; Converts :oppo/cur-ticket to :oppo/cur-ticket--sym
                  {:on-change--sym! #(on-change! attr %)
                   :value--sym      (attr entity)})))])))

;; Special settings for different fields
(defn card-field
  [_]
  (fn
    [{:keys [field entity accounts tenant-roles guest-accounts options attachments field-description

             error? mandatory? hide-empty-fields? read-only?
             search-entity! create-entity! get-entity!

             modify! on-save! cancel-edit! validate! company-curtain-start-edit!] :as _view-args}]
    (let [content (cond
                    (= (:type field) "attachments")
                    [card-field-input
                     {:field              (merge field
                                                 {:attachments attachments})
                      :entity             entity
                      :field-description  field-description
                      :mandatory?         mandatory?
                      :hide-empty-fields? hide-empty-fields?
                      :read-only?         read-only?
                      :accounts           accounts
                      :guest-accounts     guest-accounts
                      :on-change!         modify!
                      :on-save!           on-save!
                      :validate!          validate!
                      :cancel-edit!       cancel-edit!}]

                    (= (:type field) "company-name")
                    [card-field-input
                     {:field              (merge field
                                                 {:company-id (:db/id entity)
                                                  :company-curtain-start-edit!
                                                  (partial company-curtain-start-edit!
                                                           (:db/id entity))})
                      :entity             entity
                      :field-description  field-description
                      :mandatory?         mandatory?
                      :hide-empty-fields? hide-empty-fields?
                      :error?             error?
                      :options            options
                      :accounts           accounts
                      :on-change!         modify!
                      :on-save!           on-save!
                      :validate!          validate!
                      :cancel-edit!       cancel-edit!}]

                    :else
                    [card-field-input
                     {:field              field
                      :entity             entity
                      :field-description  field-description
                      :mandatory?         mandatory?
                      :hide-empty-fields? hide-empty-fields?
                      :error?             error?
                      :read-only?         read-only?
                      :options            options
                      :accounts           accounts
                      :tenant-roles       tenant-roles
                      :search-entity!     search-entity!
                      :create-entity!     create-entity!
                      :get-entity!        get-entity!
                      :validate!          validate!
                      :on-change!         modify!
                      :on-save!           on-save!
                      :cancel-edit!       cancel-edit!}])]
      (when content
        [:div
         (merge
          {:class-name "card-content"}
          (:size field))
         content]))))

(defn is-card-visible?
  [card available-in-view?]
  (let [field-visible? (fn [field]
                         (available-in-view? (or (:visibility-attribute field)
                                                 (:attribute field))))]
    (some->> card
             :fields
             (flatten)
             (filter field-visible?)
             (count)
             (pos?))))

(defn card-main
  [view-args]
  (let [card (:card view-args)
        is-sub? (:is-sub? view-args)
        card-atom (r/atom {:is-card-open? (not= (:expanded card) "closed")})
        toggle-card-atom! (fn [k v]
                            (swap! card-atom assoc k v))
        watcher-key (keyword (gensym))
        expand-watcher (fn [_k _a _o _n]
                         (toggle-card-atom! :is-card-open? true))]
    (when (and (not (:expand-watch @card-atom))
               (:expand-clicked view-args))
      (swap! card-atom assoc :expand-watch watcher-key)
      (add-watch (:expand-clicked view-args) watcher-key expand-watcher))
    (fn
      [{:keys [card template-entities entity-errors modify-entities! save-entities! add-person!
               on-add-person! validate!
               available-in-view? field-error? mandatory? hide-empty-fields?]
        :as   view-args}]
      (let [visible-fields
            (remove
             nil?
             (doall
              (for [row (:fields card)
                    :let [fields
                          (doall
                           (for [field row
                                 ;; Check if field is available to the tenant/user
                                 :let [entity (get template-entities (:entity field))
                                       value (get entity (:attribute field))
                                       empty? (or (nil? value)
                                                  (cond (string? value) (empty? value)
                                                        (set? value) (empty? value)
                                                        :else false))
                                       available? (and (or (not hide-empty-fields?)
                                                           (not empty?))
                                                       (available-in-view?
                                                        (or (:visibility-attribute field)
                                                            (:attribute field))))
                                       error? (field-error? field entity entity-errors)]
                                 :when available?]
                             ^{:key (:field-key field)}
                             [card-field
                              (merge
                               view-args
                               {:field      field
                                :mandatory? (when mandatory? (mandatory? (:attribute field)))}
                               {:entity      (get template-entities (:entity field))
                                :error?      error?
                                :validate!   (when validate! (partial validate! (:attribute field)))
                                :modify!     (or (get modify-entities! (:entity field))
                                                 (get modify-entities! :default))
                                :on-save!    (or (get save-entities! (:entity field))
                                                 (get save-entities! :default))
                                :add-person! (when (and add-person! on-add-person!)
                                               (partial add-person!
                                                        (partial on-add-person!
                                                                 field
                                                                 entity
                                                                 (:attribute field))))})]))]
                    :when (> (count (remove nil? fields)) 0)]
                ^{:key (str "clearfix-" (:field-key (first row)))}

                fields)))
            card-visible? (> (count visible-fields) 0)]
        (when card-visible?
          [card/card
           [card/header
            [:div
             {:class-name (fu/cs (if is-sub?
                                   "deal-card__title__sub"
                                   "deal-card__title__field")
                                 (when-not (:variant card)
                                   "deal-card__title__green deal-card__title__left"))
              :on-click   #(->> @card-atom
                                :is-card-open?
                                (not)
                                (toggle-card-atom! :is-card-open?))}
             (:card-name card)]]
           ;; This makes sure that rows are fixed with certain number of fields
           (when card-visible?
             [:div
              {:class "px-3"}
              ;; Render the fields
              visible-fields])])))))
